@let title = text(question.type!.endsWith('VIDEO') ? 'no-video' : null);
@if (title) {
  <div #label id="{{ question.id }}-label-content" [innerHTML]="title"></div>
}

@if (controlHasError()) {
  <div class="alert alert-danger error pill form-error-list">
    <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
      <ul>
        @for (err of baseForm.errorMap.get(question.id!); track err) {
          <li>
            <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
}

@if (baseForm.interviewState()?.errors?.validations) {
  <div class="alert alert-warning warning pill form-warning-list row my-3" [attr.aria-live]="'assertive'">
    <i class="fa fa-info-circle col-1 my-auto" aria-hidden="true"></i>
    <ul class="col-10 my-3 mx-3">
      @for (validation of baseForm.interviewState()?.errors?.validations | keyvalue; track $index) {
        <li>{{ validation.value }}</li>
      }
    </ul>
  </div>
}

@if (control) {
  <ng-container>
    <div class="row">
      <div class="col-12">
        @if (question.type === "LARGE_TEXT" || question.type?.endsWith('VIDEO')) {
          <textarea #input [attr.name]="question.id"
                    [attr.id]="question.id"
                    class="form-control {{inputClass}}"
                    [attr.autocomplete]="determineAutocompleteValue(question.id!)"
                    [required]="question.required || false" [attr.aria-required]="question.required"
                    [attr.aria-invalid]="controlHasError()"
                    [formControl]="control | asFormControl"
                    (blur)="revalidateInput()"
                    (input)="onValueChange($event);revalidateInput()"
                    [attr.aria-labelledby]="getAriaLabels('label')"
                    [attr.aria-label]="getLabel()"
                    [ngClass]="{ 'is-invalid': controlHasError() }"
                    placeholder="{{ messages.getText('label.text.placeholder') }}">
          </textarea>
        } @else {
          <input #input [attr.name]="question.id"
                 [attr.id]="question.id"
                 class="form-control {{inputClass}}"
                 [attr.autocomplete]="determineAutocompleteValue(question.id!)"
                 [required]="question.required || false" [attr.aria-required]="question.required"
                 [attr.aria-invalid]="controlHasError()"
                 [formControl]="control | asFormControl"
                 (blur)="revalidateInput()"
                 (input)="onValueChange($event);revalidateInput()"
                 [attr.aria-labelledby]="getAriaLabels('label')"
                 [attr.aria-label]="getLabel()"
                 [ngClass]="{ 'is-invalid': controlHasError() }"
                 placeholder="{{ messages.getText('label.text.placeholder') }}">
        }

        @if (!!control.validator && (baseForm.isSubmitted() || control.touched)) {
          <div #feedback
               class="feedback-icon" aria-hidden="true">
            <i class="fa" aria-hidden="true"
               [ngClass]="{ 'fa-check-circle' : !controlHasError(), 'fa-times-circle' : controlHasError() }"></i>
          </div>
        }
      </div>
    </div>
    @if (standalone) {
      <div class="option-row row mx-0 mt-6 mb-2">
        <div class="px-0 text-end">
          <button class="btn primary confirm-button rounded-pill"
                  [disabled]="baseForm.loading || baseForm.preventSave"
                  [attr.aria-label]="getLabel() + '.confirm_button'"
                  (click)="onEnter($event)"
                  (keydown.enter)="onEnter($event)">
            @if (baseForm.loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{ messages.getText('WILL.button.save-and-continue') }}
          </button>
        </div>
      </div>
    }
    <ng-content></ng-content>
  </ng-container>
}

